import { BtixConstant } from "../constant";
/**
 * セレクトボックスがdisabledの時に必要なCSS処理
 *
 * MEMO: 今回CSS/JSで対応せざるを得ないデザインだったためやむなく…
 *
 * セレクトボックスをdisabledにした際、overlayのspanもclassを追加する必要がある。
 * 本案件におけるセレクトボックスは、見た目を整えるためにオーバーレイで矢印を生成しているため。
 */
export const initSelectBox = () => {
    const selectBoxList = document.querySelectorAll(".form-select select:disabled");
    if (!selectBoxList)
        throw new Error("'selectBoxList' is not found.");
    for (const selectBox of selectBoxList) {
        disableSelectBox(selectBox);
    }
};
export const enableSelectBox = (selectBox) => {
    switchSelectBox(selectBox, true);
};
export const disableSelectBox = (selectBox) => {
    switchSelectBox(selectBox, false);
};
/**
 * 特定のセレクトボックスをJSでdisabledにした際に実行されるべき処理
 *
 * ここでオーバーレイの矢印色を変更している
 */
const switchSelectBox = (selectBox, disabled) => {
    const formSelectOverlay = ".form-select-overlay";
    const disabledClass = "form-disabled";
    if (BtixConstant.debugMode)
        window.console.log("init selectBox: ", selectBox);
    const overlay = selectBox.closest(formSelectOverlay);
    if (!overlay)
        throw new Error("'overlay' is not found.");
    if (disabled) {
        overlay.classList.add(disabledClass);
    }
    else {
        overlay.classList.remove(disabledClass);
    }
};
